export default __webpack_public_path__ + "assets/Compare4.png";